import React from 'react';

export default function ReportNav({ pages, currentIdx, onGoTo }) {
  const total = pages.length;
  const safeIdx = Math.max(0, Math.min(currentIdx, total - 1));
  const current = pages[safeIdx];
  const progressPct = total > 0 ? Math.round(((safeIdx + 1) / total) * 100) : 0;

  const prev = () => onGoTo(safeIdx - 1);
  const next = () => onGoTo(safeIdx + 1);

  return (
    <nav
      aria-label="报告分页导航"
      style={{
        position: 'sticky', top: 0, zIndex: 10,
        background: 'var(--color-bg, #fff)',
        borderBottom: '1px solid var(--color-border, #e2e8f0)',
        padding: '0 0 8px',
      }}
    >
      <div
        role="progressbar"
        aria-valuenow={safeIdx + 1}
        aria-valuemin={1}
        aria-valuemax={total}
        style={{ height: 3, background: 'var(--color-border, #e2e8f0)' }}
      >
        <div
          style={{
            height: '100%', width: `${progressPct}%`,
            background: 'var(--color-primary, #1a3a6b)',
            transition: 'width 0.3s ease',
          }}
        />
      </div>
      <div
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '10px 20px', maxWidth: 880, margin: '0 auto',
        }}
      >
        <button
          type="button"
          onClick={prev}
          disabled={safeIdx === 0}
          aria-label="上一页"
          data-testid="report-nav-prev"
          style={{
            border: 0, background: 'transparent', fontSize: 22,
            cursor: safeIdx === 0 ? 'not-allowed' : 'pointer',
            opacity: safeIdx === 0 ? 0.3 : 1,
            color: 'var(--color-primary, #1a3a6b)', padding: '4px 12px',
          }}
        >
          ‹
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ display: 'flex', gap: 6 }}>
            {pages.map((p, i) => (
              <button
                key={p.id}
                type="button"
                onClick={() => onGoTo(i)}
                aria-label={`跳到第 ${i + 1} 页：${p.title}`}
                aria-current={i === safeIdx ? 'page' : undefined}
                data-testid={`report-nav-dot-${i}`}
                style={{
                  width: 10, height: 10, borderRadius: '50%',
                  border: 0, padding: 0, cursor: 'pointer',
                  background: i === safeIdx
                    ? 'var(--color-primary, #1a3a6b)'
                    : 'var(--color-border, #cbd5e1)',
                  transition: 'background 0.2s',
                }}
              />
            ))}
          </div>
          <span
            data-testid="report-nav-counter"
            style={{ fontSize: 12, color: 'var(--color-text-muted, #64748b)', minWidth: 56, textAlign: 'center' }}
          >
            {safeIdx + 1} / {total}
            <span style={{ marginLeft: 6, opacity: 0.7 }}>{current?.title || ''}</span>
          </span>
        </div>
        <button
          type="button"
          onClick={next}
          disabled={safeIdx >= total - 1}
          aria-label="下一页"
          data-testid="report-nav-next"
          style={{
            border: 0, background: 'transparent', fontSize: 22,
            cursor: safeIdx >= total - 1 ? 'not-allowed' : 'pointer',
            opacity: safeIdx >= total - 1 ? 0.3 : 1,
            color: 'var(--color-primary, #1a3a6b)', padding: '4px 12px',
          }}
        >
          ›
        </button>
      </div>
    </nav>
  );
}
